import React from 'react';
import { Box, Chip, Container, Stack, Typography } from '@mui/material';
import { SmartToy as SmartToyIcon } from '@mui/icons-material';

const AgentsSection = () => (
  <Box
    sx={{
      py: 8,
      background: 'linear-gradient(135deg, #e8eaf6 0%, #d8ddf5 100%)',
      position: 'relative',
      zIndex: 1,
      borderTop: '1px solid rgba(63,81,181,0.12)',
      borderBottom: '1px solid rgba(63,81,181,0.12)'
    }}
  >
    <Container maxWidth="md">
      <Box sx={{ textAlign: 'center' }}>
        <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center' }}>
          <SmartToyIcon sx={{ fontSize: 56, color: '#3f51b5' }} />
        </Box>
        <Typography variant="h3" sx={{ fontWeight: 700, mb: 3, color: '#3f51b5' }}>
          AI Agents for Complex Document Workflows
        </Typography>
        <Typography variant="h6" sx={{ color: '#333', mb: 4, lineHeight: 1.7, maxWidth: 700, mx: 'auto' }}>
          Conversational agents that understand your document flows. @mention policies, tasks, and documents for instant context. Human-in-the-loop review workflow. Manage multi-step document intelligence tasks through a natural language interface.
        </Typography>
        <Stack direction="row" spacing={2} justifyContent="center" flexWrap="wrap" useFlexGap>
          <Chip
            label="@mention context"
            sx={{ fontWeight: 600, fontSize: '0.9rem', px: 1, bgcolor: 'rgba(63,81,181,0.1)', color: '#3f51b5', border: '1px solid rgba(63,81,181,0.3)' }}
          />
          <Chip
            label="Human review loop"
            sx={{ fontWeight: 600, fontSize: '0.9rem', px: 1, bgcolor: 'rgba(63,81,181,0.1)', color: '#3f51b5', border: '1px solid rgba(63,81,181,0.3)' }}
          />
          <Chip
            label="Multi-step workflows"
            sx={{ fontWeight: 600, fontSize: '0.9rem', px: 1, bgcolor: 'rgba(63,81,181,0.1)', color: '#3f51b5', border: '1px solid rgba(63,81,181,0.3)' }}
          />
        </Stack>
      </Box>
    </Container>
  </Box>
);

export default AgentsSection;
